import { render, staticRenderFns } from "./RegionDashboard.vue?vue&type=template&id=0ecb39b1&"
import script from "./RegionDashboard.vue?vue&type=script&lang=js&"
export * from "./RegionDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports